"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValues = exports.defaultConfig = void 0;
const addressType = 'Delivery'; // create value of type AddressType

const defaultValues = exports.defaultValues = {
  isPrimary: false,
  addressType,
  country: '',
  region: '',
  province: '',
  district: '',
  area: '',
  city: '',
  locality: '',
  streetAddress: '',
  zipcode: '',
  delivery: '',
  delivery2: '',
  delivery3: ''
};
const defaultConfig = exports.defaultConfig = {
  identityUrl: '',
  globalApiUrl: '',
  currentLanguage: '',
  staticApiUrl: '',
  tenant: '',
  processContext: 'Profile',
  formattedToken: '',
  token: ''
};
//# sourceMappingURL=defaultValues.js.map